import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { Link, graphql } from 'gatsby'
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import "../../styles/pc/page/publication/media/media_id.scss"
import "../../styles/sp/page/publication/media/media_id.scss"

export default function MediaPost({ data }) {
  const info = data.microcmsPublications
  return (
    <Layout>
      <Seo
        type="article"
        title="ジェイフィールの出版書籍、メディア掲載 メディア掲載詳細"
        description=""
        bobyClassName="menu13"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/publication">Publication</Link>　/　<Link to="/publication/media">Media</Link>　/　<Link to={`/publication/media/` + info.publicationsId } className="current">{ info.title }</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents_01">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              {/* <div className="inner_title">
                <div className="inner_title_in">
                  <h5 className="maintitle_left"><span><Link to="/publication/media">Media</Link></span></h5>
                </div>
              </div> */}
              <div className="publication_wrap">
                <div className="cnt_box">
                  <LazyAndPreloadImage className="publication_img" imgUrl={info.display_image ? info.display_image.url : ''} alt="メディア掲載詳細" />
                  <dl className="detail_media">
                    <dt className="ttl_media">{info.title}</dt>
                  </dl>
                  <div dangerouslySetInnerHTML={{__html: info.summary ? info.summary.replace(/\n/g, '<br />') : ''}}/>
                </div>
                { info.related_url_title_1 || info.related_url_title_2 || info.related_url_title_3 || info.download_url_title ?
                  <>
                  <div className="cnt_box">
                    <div className="bnr_madia">
                      { info.related_url_title_1 ?
                          <a target="_blank" rel="noopener noreferrer" href={info.related_url_1}>
                            <span>{info.related_url_title_1}</span>
                          </a>
                        : ''
                      }
                      { info.related_url_title_2 ?
                          <a target="_blank" rel="noopener noreferrer" href={info.related_url_2}>
                            <span>{info.related_url_title_2}</span>
                          </a>
                        : ''
                      }
                      { info.related_url_title_3 ?
                          <a target="_blank" rel="noopener noreferrer" href={info.related_url_3}>
                            <span>{info.related_url_title_3}</span>
                          </a>
                        : ''
                      }
                      { info.download_url_title ?
                          <Link to={info.download_file_url ? info.download_file_url.url : ''} className='download_link'>
                            <span>{info.download_url_title}</span>
                          </Link>
                        : ''
                      }
                      { info.download_url_title_2 ?
                          <Link to={info.download_file_url_2 ? info.download_file_url_2.url : ''} className='download_link'>
                            <span>{info.download_url_title_2}</span>
                          </Link>
                          : ''
                      }
                      { info.download_url_title_3 ?
                          <Link to={info.download_file_url_3 ? info.download_file_url_3.url : ''} className='download_link'>
                            <span>{info.download_url_title_3}</span>
                          </Link>
                          : ''
                      }
                    </div>
                  </div>
                  </>
                  : ''
                }
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}
        <div className="contents_02">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}

            { data.allMicrocmsPublications ?
            <>
            <div className="inner_title">
              <div className="inner_title_in">
                <h4 className="maintitle"><span>Media</span></h4>
                <p className="subtitle"><span>メディア掲載</span></p>
              </div>
              <div className="more"><Link to="/publication/media"><span>view more</span></Link></div>
            </div>
            <div className="publication_wrap">
              <ul className="publication_box release">
                {data.allMicrocmsPublications.edges.map(({ node }) => (
                  <li key={node.publicationsId}>
                    <Link to={'/publication/media/' + node.publicationsId}>
                      <div className="box_gray">
                        <LazyAndPreloadImage imgUrl={node.display_image ? node.display_image.url : ''} alt="メディア掲載一覧" />
                      </div>
                      <p>{node.title}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            </>

            : ''
            }

            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Publication - </span><span className="txt">出版書籍、メディア掲載</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query MediaIdQuery($id: String!) {
  microcmsPublications(publicationsId: {eq: $id}) {
    publicationsId
    title
    summary
    display_image {
      url
    }
    related_url_title_1
    related_url_1
    related_url_title_2
    related_url_2
    related_url_title_3
    related_url_3
    download_url_title
    download_file_url {
      url
    }
    download_url_title_2
    download_file_url_2 {
      url
    }
    download_url_title_3
    download_file_url_3 {
      url
    }
  }

  allMicrocmsPublications(
    limit: 2,
    filter: {publicationsId: {ne: $id}, type: {eq: "メディア掲載"}},
    sort: {fields: [release_date], order: DESC}
  ) {
    edges {
      node {
        publicationsId
        display_image {
          url
        }
        title
      }
    }
  }
}`
